import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class AddressAddresseeReferenceService extends BaseReferenceService {
  constructor() {
    super('AddressAddresseeReference');
  }

  getForAddress(addressId: string): Observable<IdDescription[]> {
    return !addressId ? of([]) : this.httpService.get<IdDescription[]>(`${this.apiUrl}/Address/${addressId}`);
  }
}
